export default __webpack_public_path__ + "static/media/640_private03-nl-web.97db6f6e.png";